import React, { useState } from 'react';
import Sidebar from '../../components/ui/Sidebar';
import ProjectSwitcher from '../../components/ui/ProjectSwitcher';
import UserAccountMenu from '../../components/ui/UserAccountMenu';
import AssetCard from './components/AssetCard';
import AssetToolbar from './components/AssetToolbar';
import AssetFilters from './components/AssetFilters';
import FolderBreadcrumb from './components/FolderBreadcrumb';
import UploadZone from './components/UploadZone';
import AssetPreviewModal from './components/AssetPreviewModal';
import AssetListView from './components/AssetListView';
import Icon from '../../components/AppIcon';


const AssetManager = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [viewMode, setViewMode] = useState('grid');
  const [selectedAssets, setSelectedAssets] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [activeFilter, setActiveFilter] = useState('all');
  const [sortBy, setSortBy] = useState('date-desc');
  const [currentPath, setCurrentPath] = useState('/');
  const [showUploadZone, setShowUploadZone] = useState(false);
  const [previewAsset, setPreviewAsset] = useState(null);

  const mockAssets = [
  {
    id: 1,
    name: 'hero-banner.jpg',
    type: 'image',
    format: 'JPG',
    size: 2457600,
    uploadDate: '12/24/2025',
    thumbnail: "https://images.unsplash.com/photo-1716378791634-90023faf85f3",
    thumbnailAlt: 'Modern office workspace with laptop computer and coffee cup on wooden desk with natural lighting',
    tags: ['hero', 'banner', 'homepage'],
    dimensions: '1920x1080',
    usedIn: ['E-commerce Store', 'Portfolio Website']
  },
  {
    id: 2,
    name: 'product-showcase.mp4',
    type: 'video',
    format: 'MP4',
    size: 15728640,
    uploadDate: '12/23/2025',
    thumbnail: "https://images.unsplash.com/photo-1686061593147-0486fbe9448b",
    thumbnailAlt: 'Professional video camera recording equipment setup with studio lighting and tripod',
    tags: ['product', 'demo', 'marketing'],
    dimensions: '1920x1080',
    usedIn: ['E-commerce Store']
  },
  {
    id: 3,
    name: 'company-logo.svg',
    type: 'icon',
    format: 'SVG',
    size: 8192,
    uploadDate: '12/22/2025',
    thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_106227c7f-1766503694350.png",
    thumbnailAlt: 'Minimalist geometric logo design with abstract shapes in teal and amber colors',
    tags: ['logo', 'branding', 'icon'],
    usedIn: ['E-commerce Store', 'Portfolio Website', 'Blog Platform']
  },
  {
    id: 4,
    name: 'user-guide.pdf',
    type: 'document',
    format: 'PDF',
    size: 1048576,
    uploadDate: '12/21/2025',
    thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_198ffedb6-1766237846865.png",
    thumbnailAlt: 'Open document with text and diagrams on white paper with pen and glasses nearby',
    tags: ['documentation', 'guide', 'help'],
    usedIn: ['E-commerce Store']
  },
  {
    id: 5,
    name: 'team-photo.jpg',
    type: 'image',
    format: 'JPG',
    size: 3145728,
    uploadDate: '12/20/2025',
    thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1b0744f9a-1765646427860.png",
    thumbnailAlt: 'Diverse group of young professionals smiling together in modern office environment with bright natural lighting',
    tags: ['team', 'about', 'people'],
    dimensions: '2400x1600',
    usedIn: ['Portfolio Website']
  },
  {
    id: 6,
    name: 'feature-icon-set.svg',
    type: 'icon',
    format: 'SVG',
    size: 16384,
    uploadDate: '12/19/2025',
    thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_156390ab9-1764688221752.png",
    thumbnailAlt: 'Collection of colorful minimalist icons arranged in grid pattern showing various interface elements',
    tags: ['icons', 'ui', 'features'],
    usedIn: ['E-commerce Store', 'Blog Platform']
  },
  {
    id: 7,
    name: 'testimonial-video.mp4',
    type: 'video',
    format: 'MP4',
    size: 20971520,
    uploadDate: '12/18/2025',
    thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1b32d89ee-1763296797785.png",
    thumbnailAlt: 'Professional woman speaking to camera in bright office setting with plants and modern decor',
    tags: ['testimonial', 'customer', 'review'],
    dimensions: '1920x1080',
    usedIn: ['E-commerce Store']
  },
  {
    id: 8,
    name: 'pricing-table-bg.jpg',
    type: 'image',
    format: 'JPG',
    size: 1572864,
    uploadDate: '12/17/2025',
    thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_16f6a9f8a-1764668406452.png",
    thumbnailAlt: 'Abstract gradient background with soft blue and purple colors creating modern tech aesthetic',
    tags: ['background', 'pricing', 'design'],
    dimensions: '1920x1080',
    usedIn: ['Portfolio Website']
  },
  {
    id: 9,
    name: 'api-documentation.pdf',
    type: 'document',
    format: 'PDF',
    size: 2097152,
    uploadDate: '12/16/2025',
    thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1c9a2774c-1766776232421.png",
    thumbnailAlt: 'Technical documentation pages with code snippets and diagrams on desk with laptop',
    tags: ['api', 'documentation', 'technical'],
    usedIn: ['Blog Platform']
  },
  {
    id: 10,
    name: 'mobile-mockup.png',
    type: 'image',
    format: 'PNG',
    size: 4194304,
    uploadDate: '12/15/2025',
    thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_12e894ec8-1765691571808.png",
    thumbnailAlt: 'Modern smartphone displaying mobile app interface with clean design on white background',
    tags: ['mockup', 'mobile', 'design'],
    dimensions: '1080x1920',
    usedIn: ['E-commerce Store', 'Portfolio Website']
  },
  {
    id: 11,
    name: 'social-media-icons.svg',
    type: 'icon',
    format: 'SVG',
    size: 12288,
    uploadDate: '12/14/2025',
    thumbnail: "https://images.unsplash.com/photo-1516053055290-2863d8bd601e",
    thumbnailAlt: 'Set of popular social media platform icons including Facebook Twitter Instagram in modern flat design',
    tags: ['social', 'icons', 'footer'],
    usedIn: ['E-commerce Store', 'Portfolio Website', 'Blog Platform']
  },
  {
    id: 12,
    name: 'blog-header.jpg',
    type: 'image',
    format: 'JPG',
    size: 2621440,
    uploadDate: '12/13/2025',
    thumbnail: "https://images.unsplash.com/photo-1701691282435-c54d51e501b4",
    thumbnailAlt: 'Person typing on laptop keyboard with coffee cup and notebook on wooden desk in cozy workspace',
    tags: ['blog', 'header', 'writing'],
    dimensions: '1920x1080',
    usedIn: ['Blog Platform']
  }];


  const handleSelectAsset = (assetId) => {
    setSelectedAssets((prev) =>
    prev?.includes(assetId) ?
    prev?.filter((id) => id !== assetId) :
    [...prev, assetId]
    );
  };

  const handleClearSelection = () => {
    setSelectedAssets([]);
  };

  const handleBulkDelete = () => {
    if (window.confirm(`Delete ${selectedAssets?.length} selected asset(s)?`)) {
      setSelectedAssets([]);
    }
  };

  const handlePreview = (asset) => {
    setPreviewAsset(asset);
  };

  const handleDeleteAsset = (assetId) => {
    if (window.confirm('Are you sure you want to delete this asset?')) {
      setPreviewAsset(null);
    }
  };

  const handleDownloadAsset = (assetId) => {
    console.log('Downloading asset:', assetId);
  };

  const filteredAssets = mockAssets?.filter((asset) => {
    const matchesSearch = asset?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    asset?.tags?.some((tag) => tag?.toLowerCase()?.includes(searchQuery?.toLowerCase()));
    const matchesFilter = activeFilter === 'all' ||
    activeFilter === 'images' && asset?.type === 'image' ||
    activeFilter === 'videos' && asset?.type === 'video' ||
    activeFilter === 'documents' && asset?.type === 'document' ||
    activeFilter === 'icons' && asset?.type === 'icon';
    return matchesSearch && matchesFilter;
  });

  return (
    <div className="min-h-screen bg-background flex">
      <Sidebar
        isCollapsed={isSidebarCollapsed}
        onToggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)} />

      <div
        className={`flex-1 flex flex-col transition-all duration-250 ${
        isSidebarCollapsed ? 'lg:ml-20' : 'lg:ml-60'}`
        }>

        <div className="hidden lg:block">
          <ProjectSwitcher
            currentProject={{ id: 1, name: 'Current Project' }}
            onProjectChange={(project) => console.log('Project changed:', project)} />

        </div>

        <AssetToolbar
          viewMode={viewMode}
          onViewModeChange={setViewMode}
          selectedCount={selectedAssets?.length}
          onUpload={() => setShowUploadZone(true)}
          onCreateFolder={() => console.log('Create folder')}
          onBulkDelete={handleBulkDelete}
          onClearSelection={handleClearSelection} />


        <AssetFilters
          searchQuery={searchQuery}
          onSearchChange={setSearchQuery}
          activeFilter={activeFilter}
          onFilterChange={setActiveFilter}
          sortBy={sortBy}
          onSortChange={setSortBy} />


        <FolderBreadcrumb
          currentPath={currentPath}
          onNavigate={setCurrentPath} />


        <main className="flex-1 overflow-y-auto p-4 md:p-6 lg:p-8">
          {filteredAssets?.length === 0 ?
          <div className="flex flex-col items-center justify-center py-16 md:py-24">
              <div className="w-20 h-20 md:w-24 md:h-24 bg-muted rounded-full flex items-center justify-center mb-4">
                <Icon name="Search" size={40} className="text-muted-foreground" />
              </div>
              <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-2">
                No assets found
              </h3>
              <p className="text-sm md:text-base text-muted-foreground text-center max-w-md">
                Try adjusting your search or filters to find what you're looking for
              </p>
            </div> :
          viewMode === 'grid' ?
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
              {filteredAssets?.map((asset) =>
            <AssetCard
              key={asset?.id}
              asset={asset}
              isSelected={selectedAssets?.includes(asset?.id)}
              onSelect={handleSelectAsset}
              onPreview={handlePreview}
              onAction={(id) => console.log('Action for:', id)} />

            )}
            </div> :

          <AssetListView
            assets={filteredAssets}
            selectedAssets={selectedAssets}
            onSelect={handleSelectAsset}
            onPreview={handlePreview}
            onAction={(id) => console.log('Action for:', id)} />

          }
        </main>

        <div className="hidden lg:block">
          <UserAccountMenu
            user={{ name: 'User', email: 'user@example.com' }}
            onLogout={() => console.log('Logout')} />

        </div>
      </div>
      {showUploadZone &&
      <UploadZone
        onUpload={() => {
          setShowUploadZone(false);
          console.log('Upload completed');
        }}
        onClose={() => setShowUploadZone(false)} />

      }
      {previewAsset &&
      <AssetPreviewModal
        asset={previewAsset}
        onClose={() => setPreviewAsset(null)}
        onDelete={handleDeleteAsset}
        onDownload={handleDownloadAsset} />

      }
    </div>);

};

export default AssetManager;